import BeneficiaryService from '../../services/portefeuille/BeneficiaryService'
import PortefeuilleService from '../../services/portefeuille/PortefeuilleService'

const Beneficiaries = {
    namespaced: true,
    state: {
        listeBeneficiaries: [],
        count: 0,
        errors: {},
        loading: false
    },
    getters: {
        listeBeneficiaries: state => state.listeBeneficiaries,
        count: state => state.count,
        loading: state => state.loading
    },
    mutations: {
        setLoadingState(state, loading) {
            state.loading = loading
        },
        setBeneficiaries(state, beneficiaries) {
            state.listeBeneficiaries = Array.isArray(beneficiaries) ? beneficiaries : []
            state.count = state.listeBeneficiaries.length
            state.errors = {}
        },
        addBeneficiaryCommit(state, beneficiary) {
            state.listeBeneficiaries.push(beneficiary)
            state.count = state.listeBeneficiaries.length
        },
        updateBeneficiaryCommit(state, updatedBeneficiary) {
            const index = state.listeBeneficiaries.findIndex(b => b._id === updatedBeneficiary._id)
            if (index !== -1) {
                state.listeBeneficiaries.splice(index, 1, updatedBeneficiary)
            }
        },
        removeBeneficiaryCommit(state, beneficiaryId) {
            state.listeBeneficiaries = state.listeBeneficiaries.filter(b => b._id !== beneficiaryId)
            state.count = state.listeBeneficiaries.length
        },
        setErrors(state, error) {
            state.errors = error
        }
    },
    actions: {
        async fetchBeneficiaries({commit}) {
            commit('setLoadingState', true)
            try {
                const response = await PortefeuilleService.getPortefeuille()
                const beneficiaries = (response.data.portefeuille && response.data.portefeuille.beneficiaires) || []
                commit('setBeneficiaries', beneficiaries)
                return beneficiaries
            } catch (error) {
                console.error('Erreur chargement beneficiaires:', error)
                commit('setErrors', error)
                throw error
            } finally {
                commit('setLoadingState', false)
            }
        },
        async addBeneficiary({commit, dispatch}, beneficiaryData) {
            try {
                const response = await BeneficiaryService.createBeneficiary(beneficiaryData)
                const createdBeneficiary = response && response.data && response.data.result

                await dispatch('fetchBeneficiaries')
                return createdBeneficiary || null
            } catch (error) {
                console.error('Erreur ajout beneficiaire:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async updateBeneficiary({commit, dispatch}, {id, beneficiaryData}) {
            try {
                await BeneficiaryService.updateBeneficiary(id, beneficiaryData)
                const beneficiaries = await dispatch('fetchBeneficiaries')

                return beneficiaries.find(beneficiary => beneficiary._id === id) || null
            } catch (error) {
                console.error('Erreur modification beneficiaire:', error)
                commit('setErrors', error)
                throw error
            }
        },
        async deleteBeneficiary({commit}, beneficiaryId) {
            try {
                const response = await BeneficiaryService.deleteBeneficiary(beneficiaryId)
                const deletionResult = response && response.data && (response.data.response || response.data)

                if (!deletionResult || deletionResult.deletedCount !== 1) {
                    throw new Error('Beneficiary deletion was not acknowledged by the API')
                }

                commit('removeBeneficiaryCommit', beneficiaryId)
            } catch (error) {
                console.error('Erreur suppression beneficiaire:', error)
                commit('setErrors', error)
                throw error
            }
        }
    }
}

export default Beneficiaries
